import { RootState } from 'modules/store';
import spacePadding from 'utils/spacePadding';
import { createSelector } from '@reduxjs/toolkit';

export const appSelector = {
	selectMessage: createSelector(
		(state: RootState) => state.app.message,
		(res) => res,
	),
	selectName: createSelector(
		(state: RootState) => state.app.name,
		(res) => res,
	),
	selectJob: createSelector(
		(state: RootState) => state.app.job,
		(res) => res,
	),
	selectSex: createSelector(
		(state: RootState) => state.app.sex,
		(res) => res,
	),
	selectSerif: createSelector(
		(state: RootState) => state.app.serif,
		(res) => res,
	),
	selectLevel: createSelector(
		(state: RootState) => state.app.level,
		(level) => {
			return spacePadding(level.toString(), 3);
		},
	),
	selectHp: createSelector(
		(state: RootState) => state.app.hp,
		(hp) => {
			return spacePadding(hp.toString(), 3);
		},
	),
	selectMp: createSelector(
		(state: RootState) => state.app.mp,
		(mp) => {
			return spacePadding(mp.toString(), 3);
		},
	),
	selectExp: createSelector(
		(state: RootState) => state.app.exp,
		(res) => res,
	),
};
